<template>
	<div id="app" class="container-fluid d-flex flex-column sticky-footer-wrapper">
		<header v-if="! isAuthRoute">
			<SideNavi :profile_name="this.$store.getters.profileGetName" />
		</header>

		<main role="main" class="flex-fill">
			<div v-if="this.$store.state.show_loading == 1" class="text-center gold mt-5 pt-5">
				<img
					:src="this.$store.state.layout.logo"
					alt="iAMc"
					width="auto"
					height="35"
					class="m-4"
				/><br />
				<i class="fas fa-atom fa-spin fa-2x"></i>
			</div>
			<div v-else>
				<router-view />
			</div>
			<pwa-prompt></pwa-prompt>
		<processing-request-modal />
		</main>
  </div>
</template>

<script>
import SideNavi from './components/SideNavi.vue';
import ProcessingRequestModal from '@/components/Dashboard/ProcessingRequestModal.vue';

import axios from '@/axios';

import * as Cookie from '@/assets/js/cookie.js';
import PwaPrompt from "@/components/PwaPrompt";

export default {
	name: 'App',
	components: {
		PwaPrompt,
		SideNavi,
		ProcessingRequestModal,
	},
	data() {
		return {
			temp: '',
      isAuthRoute: true
		};
	},
	mounted () {
		document.title = [this.$route.meta.title, 'iAMconnected App'].filter(Boolean).join(' - ');
	},
	methods: {
		checkout() {
			this.$refs.checkoutRef.redirectToCheckout();
		},
		checkVersion() {
			var cookieVersion = Cookie.getCookie('version');
			var storeVersion = this.$store.getters.appVersion;
			console.log({cookieVersion, storeVersion})
			if (cookieVersion !== storeVersion) {
				Cookie.setCookie('version', storeVersion, this.$store.state.app_domain, '3');
				Cookie.setCookie('version', storeVersion, 'iamconnected.loc', '3');
				console.log('reload APP');
				// location.reload();
			}
			cookieVersion = Cookie.getCookie('version');
			console.log('cookieVersion:' + cookieVersion);
		},
		getProfile() {
      this.$store.state.show_loading = 1

			axios({
				url: 'userGet',
				params: {
					log_session: 1,
				},
			})
				.then((response) => {
					if (response.data.profile.status == 1) {
						this.$store.commit('profileSet', response.data);

						if (typeof this.$route.meta.min_level !== 'undefined') {
							console.log(this.$route.meta.min_level);
							if (this.$route.meta.min_level === 'admin') {
								if (response.data.profile.level < 90) {
									console.log('User level not accepted - Admin Only');
									this.$router.push('/');
								}
							} else if (this.$route.meta.min_level === 'editor') {
								if (response.data.profile.level < 60) {
									console.log('User level not accepted - Editors Only');
									this.$router.push('/');
								}
							} else if (this.$route.meta.min_level === 'coach') {
								if (response.data.profile.level < 30) {
									console.log('User level not accepted - Team Coaches Only');
									this.$router.push('/');
								}
							}
            }

					} else if (response.data.profile.status == -5) {
						if (this.$route.name != 'login') {
							this.$router.push('/login');
						}
					}

					this.$store.state.show_loading = 0;
				})
				.catch(() => {
					console.log('Error: getProfile.');
				});
		},
  },
	created() {
		const tld = window.location.origin.split('.').pop();
		if (tld == 'loc') {
			this.$store.commit('appDomainSet', process.env.VUE_APP_LOCAL_DOMAIN);
			this.$store.commit('appUrlSet', process.env.VUE_APP_LOCAL_API);
		}
		Cookie.setCookie('SD', 'app', this.$store.state.app_domain, '3');
		Cookie.setCookie('SD', 'app', 'iamconnected.loc', '3');

    this.$store.state.show_loading = 0
	},
	watch: {
		$route(to) {
			document.title = to.meta.title + ' - iAMconnected App';
			this.checkVersion();

      this.$store.state.show_loading = 0
      this.isAuthRoute = to.path.startsWith('/auth') || to.path.startsWith('/login')
      if (! this.isAuthRoute) {
        this.$store.state.session_id = Cookie.getCookie('user_session');
        this.getProfile();
      }
    },
	},
};
</script>

<style scoped>
/* include main_styles.css here to override bootstrap theming on build */
@import 'https://media.iamconnected.com/css/main_styles.css';
body,
.sticky-footer-wrapper {
	min-height: 100vh;
}

.flex-fill {
	flex: 1 1 auto;
}
</style>

<style>

.ql-toolbar .ql-formats {
  .ql-clean, .ql-image, .ql-video{
    display: none !important;
  }
}

</style>
